module.exports = __webpack_public_path__ + "static/dwlogo_white-f45c177a3593a5724eafe4828aef5255.svg";